import React from 'react';

import { useThemeGetter } from '@hooks';

import { Title } from '@components/Title';
import { Characteristic } from '@components/Characteristic';

import { parseDateForJobPeriod } from '@utils';

import { FieldIcon, LocationIcon } from '@assets/icons';

import {
  JIIMG,
  Hyphen,
  JobItemInfo,
  JIIMGContainer,
  PeriodContainer,
  JobItemInfoTitle,
  JobItemContainer,
  EndPeriodContainer,
  JobItemInfoContainer,
  JobItemInfoCharacteristic,
} from './JobItem.styled';

import { JobItemProps } from './JobItem.types';

export const JobItem = ({
  id,
  avatar,
  company,
  endDate,
  onClick,
  jobTitle,
  industry,
  location,
  startDate,
  locationType,
  employmentType,
  short,
  active,
}: JobItemProps) => {
  const {
    theme: {
      BlockShadow,
      Title: TitleColor,
      Text: TextColor,
      BackgroundReverse,
      Background,
      Highlight,
    },
  } = useThemeGetter();

  return (
    <JobItemContainer
      shadow={BlockShadow}
      onClick={() => onClick(id)}
      short={short}
      background={active ? BackgroundReverse : Background}
      hoverBackground={Highlight}
    >
      <PeriodContainer short={short}>
        <Title
          text={parseDateForJobPeriod(startDate)}
          color={TitleColor}
          size={2}
          align="left"
          cursor="pointer"
        />
        <EndPeriodContainer>
          <Hyphen color={TitleColor} />
          <Title
            text={parseDateForJobPeriod(endDate)}
            color={TitleColor}
            size={2}
            align="left"
            cursor="pointer"
          />
        </EndPeriodContainer>
      </PeriodContainer>
      <JobItemInfoContainer short={short}>
        <JIIMG src={avatar} short={short} />
        <JobItemInfo>
          <JobItemInfoTitle>
            <Title
              text={company}
              size={2}
              color={TitleColor}
              align="left"
              cursor="pointer"
            />
            <Title
              text={`${jobTitle} — ${employmentType}`}
              size={1.5}
              font="SignikaLight"
              color={TitleColor}
              align="left"
              cursor="pointer"
            />
          </JobItemInfoTitle>
          <JobItemInfoCharacteristic>
            <Characteristic
              text={industry}
              textColor={TextColor}
              icon={<FieldIcon />}
            />
            <Characteristic
              text={`${location} — ${locationType}`}
              textColor={TextColor}
              icon={<LocationIcon />}
            />
          </JobItemInfoCharacteristic>
        </JobItemInfo>
      </JobItemInfoContainer>
      <JIIMGContainer short={short}>
        <JIIMG src={avatar} short={short} />
      </JIIMGContainer>
    </JobItemContainer>
  );
};
